import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_chart_of_acc_glcode_link_RowClass} from '../../dbschema';

export class ChartOfAccGLCodeLinkContainerModel extends BaseContainerModel {
  bl_fi_mst_chart_of_acc_glcode_link: bl_fi_mst_chart_of_acc_glcode_link_RowClass = new bl_fi_mst_chart_of_acc_glcode_link_RowClass();
}
